module.exports = __webpack_public_path__ + "img/idriss_s.223ab8a8.png";